import { Controller } from "@hotwired/stimulus"

// Updates a preview element with the combined first + last name as the user types.
export default class extends Controller {
  static targets = ["firstName", "lastName", "preview", "email"]

  update() {
    const first = this.hasFirstNameTarget ? this.firstNameTarget.value.trim() : ""
    const last = this.hasLastNameTarget ? this.lastNameTarget.value.trim() : ""
    const name = [first, last].filter(Boolean).join(" ")
    this.previewTarget.textContent = name || this.previewTarget.dataset.liveNamePreviewFallback || ""
    if (this.hasEmailTarget) {
      this.emailTarget.classList.toggle("hidden", !name)
    }
  }
}
